import { unwrapResult } from '@reduxjs/toolkit'
import { Col, Form, Modal, notification, Table } from 'antd'
import _, { sum } from 'lodash'
import React, { ReactElement, useContext, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { ThemeContext } from '../../../theme/ThemeContext'
import { Columns } from './column'
import { Query } from './Query'
import styles from './disqualificationBreakageManagement.module.css'
import { AddOrEditFormModal } from './addOrEditModal'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { BreakageReasonModal } from './breakageReasonModal'
import {
  getBuildInventoryLeaderAsync,
  getDBManagementExportAsync,
  getDBManagementListAsync,
  getExamineAsync,
  getRemoveAsync,
} from './disqualificationBreakageManagementSlice'
import { TableRowSelection } from 'antd/lib/table/interface'

export const DisqualificationBreakageManagementList = (props: {
  selectKey?: string
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [editTenantId, setEditTenantId] = useState<any>()

  const [lookFlag, setLookFlag] = useState(false)

  const [isBreakageModalVisible, setIsBreakageModalVisible] = useState(false)

  const [total, setTotal] = useState<any>()

  const [data, setData] = useState<any[]>([])

  const [id, setId] = useState<any>()

  const [isEdit, setIsEdit] = useState<any>()

  const [exportLoading, setExportLoading] = useState<any>(false)

  const [queries, setQueries] = useState<any>({
    current: 1,
    size: 10,
  })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [selectionType, setSelectionType] = useState<'checkbox' | 'radio'>(
    'checkbox'
  )

  const [selectIds, setSelectIds] = useState<any>()

  const rowSelection = {
    onChange: (keys: string[]) => {
      setSelectIds(keys)
    },
    getCheckboxProps: (record: any) => ({
      disabled:
        record?.isLedger == '1' || record?.examineStatus != 1  || record?.isEdit?.toString() == '0' ? true : false, // Column configuration not to be checked
    }),
  }

  const getDataList = () => {
    setPageLoading(true)
    dispatch(getDBManagementListAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    if (props?.selectKey == '2') {
      if (!queries.current) return
      getDataList()
    }
  }, [queries, props?.selectKey])

  const exportExcel = () => {
    setExportLoading(true)
    dispatch(getDBManagementExportAsync({ ...queries }))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '不合格报损管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const getAuditList = (id?: any) => {
    Modal.confirm({
      centered: true,
      title: '确认操作',
      content: (
        <div>
          <ExclamationCircleFilled style={{ color: '#FFAE55', fontSize: 18 }} />
          &nbsp;{id ? '确定要审核吗？' : '确定要全部审核吗？'}
        </div>
      ),
      okText: '确认',
      cancelText: '取消',
      icon: null,
      onOk: () => {
        dispatch(getExamineAsync(id ? id : undefined))
          .then(unwrapResult)
          .then(() => {
            notification.success({
              message: '审核成功',
            })
            getDataList()
          })
      },
      onCancel: () => {
        return false
      },
    })
  }

  return (
    <Col className={styles.content}>
      <Col
        className={styles.contentMain}
        style={{
          flex: 1,
          backgroundColor: theme.pn,
        }}
      >
        <Query
          loading={pageLoading}
          add={() => {
            setIsModalVisible(true)
            setId('')
            setIsEdit('')
            setEditTenantId('')
          }}
          allAudit={() => {
            getAuditList()
          }}
          breakage={() => {
            setIsBreakageModalVisible(true)
          }}
          exportLoading={exportLoading}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v, current: 1 })
            setSelectIds([])
          }}
          generateADamageReport={() => {
            if (selectIds?.length) {
              dispatch(
                getBuildInventoryLeaderAsync(
                  selectIds?.length ? selectIds?.join(',') : undefined
                )
              )
                .then(unwrapResult)
                .then((v) => {
                  setSelectIds([])
                  notification.success({
                    message: '操作成功',
                  })
                  getDataList()
                })
            } else {
              notification.info({
                message: '请先勾选需要生成报损单的数据',
              })
            }
          }}
          export={() => {
            exportExcel()
          }}
        />
        <EditableList
          loading={pageLoading}
          page={{
            items: data,
            current: queries.current || 1,
            size: queries.size || 10,
            total: total,
          }}
          rowKey={(record: any) => record.id}
          rowSelection={
            {
              selectedRowKeys: selectIds,
              type: selectionType,
              ...rowSelection,
            } as TableRowSelection<any>
          }
          columns={Columns((text, t: any) => {
            if (text == 'delete') {
              Modal.confirm({
                centered: true,
                title: '确认操作',
                content: (
                  <div>
                    <ExclamationCircleFilled
                      style={{ color: '#FFAE55', fontSize: 18 }}
                    />
                    &nbsp;是否确认删除？
                  </div>
                ),
                okText: '确认',
                cancelText: '取消',
                icon: null,
                onOk: () => {
                  dispatch(getRemoveAsync(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      notification.success({
                        message: '删除成功',
                      })
                      getDataList()
                    })
                },
              })
            } else if (text == 'edit') {
              setLookFlag(false)
              setIsModalVisible(true)
              setId(t?.id)
              setEditTenantId(t?.tenantId)
              setIsEdit(t?.isEdit?.toString())
            } else if (text == 'lookDetail') {
              setLookFlag(true)
              setIsModalVisible(true)
              setId(t?.id)
              setEditTenantId(t?.tenantId)
            } else if (text == 'audit') {
              getAuditList(t?.id)
            }
          }, (queries.size || 10) * ((queries.current || 1) - 1))}
          onChangePage={(current: any, size: any) => {
            setQueries({
              ...queries,
              current,
              size,
            })
          }}
          onRow={(r) => ({
            onDoubleClick: () => {
              setId(r.id)
            },
          })}
        />
      </Col>
      {/* 新增或编辑 */}
      <AddOrEditFormModal
        editTenantId={editTenantId}
        isEdit={isEdit}
        lookFlag={lookFlag}
        id={id}
        isModalVisible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setId('')
          setIsEdit('')
          setEditTenantId('')
          setLookFlag(false)
        }}
        onOk={() => {
          setIsModalVisible(false)
          setId('')
          setIsEdit('')
          setEditTenantId('')
          getDataList()
          setLookFlag(false)
        }}
      />
      {/* 过期报损原因 */}
      <BreakageReasonModal
        isModalVisible={isBreakageModalVisible}
        onCancel={() => {
          setIsBreakageModalVisible(false)
        }}
        onOk={() => {
          setIsBreakageModalVisible(false)
          getDataList()
        }}
      />
    </Col>
  )
}
